import { createSlice } from "@reduxjs/toolkit";

// moduleDataSlice.js
const initialState = {
  lead: {},
  deal: {},
  user: {},
  refetchFlags: {
    leads: false,
    deals: false,
    users: false,
  },
  reloading: false,
  //   selectedIds: {
  //     leadId: null,
  //     dealId: null,
  //     userId: null,
  //   },
};

const moduleDataSlice = createSlice({
  name: "moduleData",
  initialState,
  reducers: {
    setLead: (state, action) => {
      state.lead = action.payload;
    },
    setDeal: (state, action) => {
      state.deal = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setRefetchFlag: (state, action) => {
      const { module, flag } = action.payload;
      if (state.refetchFlags[module] !== undefined) {
        state.refetchFlags[module] = flag;
      }
    },
    resetRefetchFlag: (state, action) => {
      const module = action.payload;
      if (state.refetchFlags[module] !== undefined) {
        state.refetchFlags[module] = false;
      }
    },
    resetAllRefetchFlags: (state) => {
      Object.keys(state.refetchFlags).forEach((key) => {
        state.refetchFlags[key] = false;
      });
    },
    setReloading: (state, action) => {
      state.reloading = action.payload;
    },
    // setSelectedId: (state, action) => {
    //   const { module, id } = action.payload;
    //   if (state.selectedIds[`${module}Id`]) {
    //     state.selectedIds[`${module}Id`] = id;
    //   }
    // },
    resetModuleState: (state) => {
      state.lead = {};
      state.deal = {};
      state.user = {};
      state.refetchFlags = {
        leads: false,
        deals: false,
        users: false,
      };
      //   state.selectedIds = {
      //     leadId: null,
      //     dealId: null,
      //     userId: null,
      //   };
    },
  },
});

export const {
  setLead,
  setDeal,
  setUser,
  setRefetchFlag,
  //   setSelectedId,
  resetModuleState,
  resetRefetchFlag,
  resetAllRefetchFlags,
  setReloading,
} = moduleDataSlice.actions;

export default moduleDataSlice.reducer;

// Dispatching actions
// dispatch(setLeads(newLeadsData));
// dispatch(setRefetchFlag({ module: 'leads', flag: true }));
// dispatch(setSelectedId({ module: 'deal', id: selectedDealId }));

// Accessing state
// const leads = useSelector((state) => state.moduleData.leads);
// const refetchLeads = useSelector((state) => state.moduleData.refetchFlags.leads);
